import { AdminAppState, EventEntry } from '../../state';
import { getEvent } from './get-event';

export const getEventPlaceId = (eventKey: string) => (
  store: AdminAppState,
): EventEntry['event']['placeId'] => getEvent(eventKey)(store).placeId;
